<button class="td-wb-split-button--button"
        type="button"
        [attr.aria-pressed]="active()"
        (click)="onSelect()">
  <ng-content select="td-wb-split-button-title" />
  <ng-content select="td-wb-split-button-data" />
</button>
